// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapCopy{
   display: none;
}

.containerId:hover .mapCopy{
    display: flex;
}

.containerId:hover .mapId{
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/AdminPages/Video/TableVideo.css"],"names":[],"mappings":"AAAA;GACG,aAAa;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".mapCopy{\n   display: none;\n}\n\n.containerId:hover .mapCopy{\n    display: flex;\n}\n\n.containerId:hover .mapId{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
